import { Pipe, PipeTransform } from '@angular/core';
import { getTypeOfRemoteDevice } from '@store';
import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateDeviceByRoles',
})
export class TranslateDeviceByRolesPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(roles: string[]): string {
    if (!roles.length) {
      return '';
    }

    const type = getTypeOfRemoteDevice(roles);

    return this.translateService.instant(this.customTranslationsService.REMOTE_DEVICE_TYPES[type]);
  }
}
